module.exports = __webpack_public_path__ + "static/media/3-3.fe22257d.mp3";